import { Input } from "design-react-kit";
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";

import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NewAnnouncement = (props) => {
  const apiToken = useContext(TokenContext);
  const query = useQuery();
  const currentYear = new Date().getFullYear();

  const [servicesList, setServicesList] = useState([]);
  const [serviceName, setServiceName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [arrRanges1, setArrRanges1] = useState([]);
  const [arrRangesFilter1, setArrRangesFilter1] = useState([]);
  const [arrRangesTemp1, setArrRangesTemp1] = useState([]);
  const [arrRanges2, setArrRanges2] = useState([]);
  const [arrRangesTemp2, setArrRangesTemp2] = useState([]);
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterRange, setFilterRange] = useState("");

  const [data, setData] = useState({
    serviceId: query.get("id"),
    name: query.get("name") ? `${query.get("name")} - ${currentYear}` : "",
    cost: null,
    bandsId: null,
    nomeMyPay: "",
    codCapitolo: "",
    codAccertamento: "",
  });

  useEffect(() => {
    if (apiToken) {
      fetchData();
    }
  }, [apiToken]);

  const fetchData = async () => {
    setLoading(true);
    try {
      if (query.get("id") && query.get("name")) {
        setServiceName(query.get("name"));
      }

      const servicesResponse = await Repo.getServices(apiToken);
      setServicesList(servicesResponse.data);

      const rangesResponse = await Repo.getRangesList(apiToken);
      setArrRanges1(rangesResponse.data);
      setArrRangesFilter1(rangesResponse.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    if (!data.serviceId) passedValidation = false;
    if (!data.name) passedValidation = false;

    const tempData = {
      ...data,
      bandsId: arrRanges2.map((x) => x.id),
      listBase64: [],
    };

    setData(tempData);

    if (passedValidation) {
      setIsOpen(true);
    }
  };

  const postInsertSession = async () => {
    try {
      const response = await Repo.postInsertSession(
        apiToken,
        JSON.stringify(data),
      );
      if (response.status === 200) {
        window.location.href = `${props.subfolder}/lista_interventi/dettaglio_intervento/modifica_intervento?sessionId=${response.data}`;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeRange = (event, percent, fixedcost) => {
    if (event) {
      const { name, id, checked, value } = event.target;

      if (name === "checkBox1") {
        if (checked) {
          setArrRangesTemp1((prevState) => [
            ...prevState,
            { id, name: value, percent, fixedCost: fixedcost },
          ]);
        } else {
          setArrRangesTemp1((prevState) =>
            prevState.filter((item) => item.id !== id),
          );
        }
      } else if (name === "checkBox2") {
        if (checked) {
          setArrRangesTemp2((prevState) => [
            ...prevState,
            { id, name: value, percent, fixedCost: fixedcost },
          ]);
        } else {
          setArrRangesTemp2((prevState) =>
            prevState.filter((item) => item.id !== id),
          );
        }
      }
    }
  };

  const transferRange = (bool) => {
    if (bool) {
      setArrRanges2((prev) => [...prev, ...arrRangesTemp1]);
      setArrRanges1((prev) =>
        prev.filter(
          (item) => !arrRangesTemp1.some((temp) => temp.id === item.id),
        ),
      );
      setArrRangesTemp1([]);
    } else {
      setArrRanges1((prev) => [...prev, ...arrRangesTemp2]);
      setArrRanges2((prev) =>
        prev.filter(
          (item) => !arrRangesTemp2.some((temp) => temp.id === item.id),
        ),
      );
      setArrRangesTemp2([]);
    }
  };

  useEffect(() => {
    if (filterRange) {
      setArrRanges1((prev) =>
        prev.filter((obj) =>
          obj.name?.toLowerCase().includes(filterRange?.toLowerCase()),
        ),
      );
    } else if (arrRanges2.length > 0 && arrRangesFilter1.length > 0) {
      setArrRanges1(
        arrRangesFilter1.filter(
          (obj) => !arrRanges2.some((obj2) => obj.id === obj2.id),
        ),
      );
    }
  }, [filterRange, arrRanges2, arrRangesFilter1]);

  const transferBlock = () => (
    <>
      <div className="row mt-4">
        <div className="col-xs-12 col-md-5">
          <Input
            id="filterRange"
            label="Ricerca Fasce Isee"
            type="text"
            name="filterRange"
            value={filterRange}
            onChange={(e) => setFilterRange(e.target.value)}
          />
        </div>
      </div>
      <div className="it-transfer-block">
        <div className="row">
          <div className="col-xs-12 col-md-5">
            <div className="it-transfer-wrapper source">
              <div className="transfer-header">
                <div className="form-check">
                  <label htmlFor="checkbox1">
                    <span>FASCE ISEE DISPONIBILI</span>
                  </label>
                </div>
              </div>
              <div className="transfer-scroll">
                <div className="transfer-group">
                  {arrRanges1.length > 0 &&
                    arrRanges1.map((x) => (
                      <div key={x.id} className="form-check">
                        <input
                          id={x.id}
                          value={x.name}
                          type="checkbox"
                          name="checkBox1"
                          onChange={(e) =>
                            handleChangeRange(e, x.percent, x.fixedCost)
                          }
                          checked={arrRangesTemp1.some((y) => y.id === x.id)}
                        />
                        <label htmlFor={x.id}>
                          <span>
                            {x.name} ({x.min} - {x.max} €)
                            <br />
                            <div className="ml-4">
                              Costo: <b>{x.costoFinale}</b>
                            </div>
                          </span>
                        </label>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-2">
            <div className="it-transfer-buttons">
              <button
                className={`transfer ${
                  arrRangesTemp1.length > 0 ? "enabled" : "disabled"
                }`}
                onClick={() => transferRange(true)}
                aria-label="Sposta avanti"
                disabled={arrRangesTemp1.length === 0}
              >
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-arrow-right`}></use>
                </svg>
              </button>
              <button
                className={`backtransfer mt-2 ${
                  arrRangesTemp2.length > 0 ? "enabled" : "disabled"
                }`}
                onClick={() => transferRange(false)}
                aria-label="Sposta indietro"
                disabled={arrRangesTemp2.length === 0}
              >
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-arrow-left`}></use>
                </svg>
              </button>
            </div>
          </div>
          <div className="col-xs-12 col-md-5">
            <div className="it-transfer-wrapper target">
              <div className="transfer-header">
                <div className="form-check">
                  <label htmlFor="checkbox1b">
                    <span>FASCE ISEE SELEZIONATE</span>
                  </label>
                </div>
              </div>
              <div className="transfer-scroll">
                <div className="transfer-group">
                  {arrRanges2.length > 0 &&
                    arrRanges2.map((x) => (
                      <div key={x.id} className="form-check">
                        <input
                          id={x.id}
                          value={x.name}
                          type="checkbox"
                          name="checkBox2"
                          onChange={(e) =>
                            handleChangeRange(e, x.percent, x.fixedCost)
                          }
                          checked={arrRangesTemp2.some((y) => y.id === x.id)}
                        />
                        <label htmlFor={x.id}>
                          <span>
                            {x.name} ({x.min} - {x.max} €)
                            <br />
                            <div className="ml-4">
                              Costo: <b>{x.costoFinale}</b>
                            </div>
                          </span>
                        </label>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <h1>Nuovo intervento</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Inserimento di un nuovo intervento per categoria</p>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={checkSession}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <div className="row m-3">
        <div className="bootstrap-select-wrapper col-lg-5">
          <label>Categoria</label>
          <Select
            aria-label="Servizio"
            clearText="Annulla"
            defaultMenuIsOpen={false}
            required
            icon={false}
            name="servizio"
            id="servizio"
            options={servicesList.map((s) => ({ value: s.id, label: s.name }))}
            onChange={(e) => {
              setData({
                ...data,
                serviceId: e ? e.value : null,
              });
              setServiceName(e ? e.label : null);
            }}
            isClearable
            isSearchable
            value={
              data.serviceId
                ? {
                    value: data.serviceId,
                    label: servicesList.find((s) => s.id === data.serviceId)
                      ?.name,
                  }
                : null
            }
            placeholder={serviceName ? serviceName : "Seleziona categoria*"}
          />
          {validation && !data.serviceId && (
            <small id="errorSelect" className="form-text text-danger">
              Il campo non può essere vuoto!
            </small>
          )}
        </div>
        <div className="col-lg-5">
          <Input
            id="title"
            label="Titolo intervento*"
            type="text"
            name="title"
            value={data.name || ""}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            className={validation && !data.name ? "is-invalid" : ""}
            infoText={
              validation && !data.name ? "Il campo non può essere vuoto!" : ""
            }
          />
        </div>
        <div className="col-lg-2 ">
          <Input
            id="anno"
            label="Anno"
            type="text"
            value={data.anno || ""}
            maxLength={4}
            onChange={(e) => {
              // Accetta solo cifre e massimo 4 caratteri
              const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
              setData({ ...data, anno: val ? parseInt(val, 10) : "" });
            }}
          />
        </div>
      </div>

      <h6>Fasce ISEE:</h6>
      {transferBlock()}

      <ModalComponent
        toggleModal={setIsOpen}
        isOpen={isOpen}
        header="Inserimento nuovo intervento"
        body="Confermi di voler inserire un nuovo intervento?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={postInsertSession}
      />
      {loading && <Loader />}
    </>
  );
};

export default NewAnnouncement;
